/* eslint-disable func-names */
import "./vendor";
import "./helpers";
import { ieFix } from "./vendor/ie-fix";
import { vhFix } from "./vendor/vh-fix";
import header from "./components/header";
import { headerFixed } from "./components/headerFixed";
import slidersInit from "./components/slider";
import modalInit from "./components/modal";
import { actualYear } from "./modules/actualYear";

actualYear();
header.init();
headerFixed();
ieFix();
vhFix();
slidersInit();
modalInit();

Fancybox.bind("[data-fancybox]", {
	locale: "ru",
	l10n: {
		ru: {
			CLOSE: "Закрыть",
			NEXT: "Следующий",
			PREV: "Предыдущий",
			MODAL: "Вы можете закрыть это окно, нажав клавиши ESC",
			ERROR: "Не удалось загрузить контент. Пожалуйста, попробуйте позже.",
			IMAGE_ERROR: "Изображение не найдено.",
			ELEMENT_NOT_FOUND: "Элемент не найден.",
			AJAX_NOT_FOUND: "Ошибка при загрузке AJAX: не найдено.",
			AJAX_FORBIDDEN: "Ошибка при загрузке AJAX: доступ запрещен.",
			IFRAME_ERROR: "Ошибка загрузки страницы.",
		},
	},
});

// Функция для вычисления высоты шапки
function updateHeaderHeight() {
	const $header = document.querySelector("header"); // Находим элемент шапки
	const headerHeight = $header.offsetHeight; // Получаем высоту шапки
	document.documentElement.style.setProperty(
		"--h-height",
		`${headerHeight}px`
	);
}

// Инициализация
document.addEventListener("DOMContentLoaded", () => {
	updateHeaderHeight(); // Вызываем функцию при загрузке страницы
	window.addEventListener("resize", updateHeaderHeight); // Вызываем функцию при изменении размера окна
});

$("select").each(function () {
	$(this).customSelect({
		block: "custom-select",
		transition: 200,
		includeValue: true,
		hideCallback: function () {
			var $value = $(this).find('[class$="value"]');
			$value.addClass("custom-select__option--select");
		},
	});

	if ($(this).is(":disabled")) {
		$(this).next(".custom-select").addClass("disabled");
	}
});
